import { http, HttpResponse } from 'msw';

export default http.post('/WEB/hello', () => HttpResponse.json('Hello'));
